module.exports = __webpack_public_path__ + "img/di2.db556fac.png";